// extracted by mini-css-extract-plugin
export default {"root":"u5ji8z71","block":"cXbH8vux"};